<template>
  <section class="notice" v-loading="loading">
    <el-dialog
      width="420px"
      :visible.sync="show"
      :close-on-press-escape="false"
      :before-close="handClose"
      :show-close="false"
    >
      <div>
        <div class="tip">消息提醒</div>
        <div class="tabless">
          <el-collapse accordion @change="handleChange">
            <el-collapse-item
              v-for="item in list"
              :key="item.id"
              :name="item.id"
            >
              <template slot="title">
                <div class="titles">
                  <div :class="{ read: item.isRead == 1, isread: item.isRead != 1 }">{{ item.noticeTitle }}</div>
                </div>
              </template>
              <div class="tb-row" @click="toDetail(item.skipUrl)">
                <span>{{ item.noticeMessage }}</span>
                <span class="detail" v-if="item.skipUrl">详情</span>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="more" @click="handMore">
          <span>更多</span>
          <i class="el-icon-arrow-right"></i>
        </div>
        <i class="close el-icon-circle-close" @click="handClose"></i>
      </div>
    </el-dialog>
  </section>
</template>
<script>

import { localStore } from "@/utils/data-management";
export default {
  data() {
    return {
      loading: false,
      list: [],
      active: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token
    },
    show() {
      if (!this.$store.state.noticeStatus && this.list.length > 0) {
        return true
      }
      return false
    },
  },
  watch:{
    token(newVal, oldVal) {
      if (newVal && newVal !== 'show') {
        this.getList()
      }
    }
  },
  methods: {
    getList() {
      this.loading = true;
      let params = {
        pageNumber: 1,
        pageSize: 10,
        userId: this.$store.state.userInfo.id,
        type: 3,
        isRead: 0
      };
      this.$api.user
        .noticeList(params)
        .then((res) => {
          if (res.code == 1000) {
            this.list = res.data;
            if (this.list.length < 1) {
              this.$store.dispatch('changeNoticeStatus', true)
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleChange(val) {
      this.active = val;
      if (val) {
        this.list.map((item) => {
          if (item.id == val) {
            if (item.isRead != 1) {
              this.readNotice(val);
            }
            item.isRead = 1;
          }
        });
      }
    },
    readNotice(id) {
      this.$api.user.noticeDoneReadDetail({ id: id }).then((res) => {});
    },
    handClose() {
      this.$store.dispatch('changeNoticeStatus', true)
    },
    handMore() {
      this.$goTo('MyNotice')
      this.$store.dispatch('changeNoticeStatus', true)
    },
    toDetail(url) {
      if (!url) return
      let data = JSON.parse(url)
      if (data.code === 1) {
        this.$goTo("InfoCollection");
      }
      if (data.code === 2) {
        this.$goTo("MyLoan");
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.notice {
  .el-dialog__wrapper {
    /deep/ .el-dialog {
      border-radius: 6px;
      &__header {
        display: none;
      }
      &__body {
        padding: 20px 0;
      }
    }
  }
  .tip {
    font-size: 24px;
    color: #282B30;
    text-align: center;
    margin: 10px 0 30px;
  }
  .tabless {
    width: 368px;
    margin: 0 auto;
    height: 380px;
    overflow: scroll;
    .titles {
      width: 340px;
      font-size: 16px;
      color: #2d2f32;
      display: flex;
      justify-content: space-between;
      .status {
        font-size: 14px;
        color: #787f8a;
      }
      .read {
        color: #2d2f32;
      }
      .read::before {
        content: "";
        width: 8px;
        height: 8px;
        background: #fff;
        border-radius: 50%;
        display: inline-block;
        margin-right: 10px;
      }
      .isread::before {
        content: "";
        width: 8px;
        height: 8px;
        background: #FF5050;
        border-radius: 50%;
        display: inline-block;
        margin-right: 10px;
      }
    }
    .tb-row {
      margin-left: 18px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;
      .detail {
        color: #999;
        margin-left: 10px;
      }
    }
  }
  .more {
    margin-top: 10px;
    text-align: right;
    i {
      margin: 0 32px 0 8px;
    }
    cursor: pointer;
  }
  .close {
    font-size: 30px;    
    position: absolute;
    top: -40px;
    color: #fff;
    right: 0px;
    cursor: pointer;
  }
}
</style>